import { getAxios } from "@coremind/identity-core";
// Dispatched on window whenever the calling user's site-menu changes (add or remove) -- lets
// AppSidebarLayout's "My Sites" section (a completely separate component, mounted the whole time
// AppStorePage is open inside it) refresh live instead of only picking up the change on next full
// page load/workspace switch. Same "custom window event" pattern workspaces-core's own
// impersonation-changed signal already uses in this codebase.
export const SITE_MENU_CHANGED_EVENT = "coremind:site-menu-changed";
function notifySiteMenuChanged() {
    if (typeof window !== "undefined") {
        window.dispatchEvent(new Event(SITE_MENU_CHANGED_EVENT));
    }
}
// GET/POST/DELETE /tenants/{tenant_id}/site-menu -- the per-user layer on top of workspace-level
// site availability (TenantSiteMembership/@coremind/workspaces-core's linkWorkspaceSite). Adding
// a site here also makes it available to the whole workspace if it wasn't already (the backend
// does both in one call); removing only un-pins it for the calling user.
export async function listMySiteMenu(tenantId) {
    const res = await getAxios().get(`/tenants/${tenantId}/site-menu`);
    return res.data ?? [];
}
export async function addMySiteMenuItem(tenantId, slug) {
    const res = await getAxios().post(`/tenants/${tenantId}/site-menu`, { slug });
    notifySiteMenuChanged();
    return res.data;
}
export async function removeMySiteMenuItem(tenantId, siteId) {
    await getAxios().delete(`/tenants/${tenantId}/site-menu/${siteId}`);
    notifySiteMenuChanged();
}
